export default {"src":"/_next/static/media/blessed-face.cfb92d0e.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};